import { Col, Container, Row, Form, Button } from "react-bootstrap";
import styled from "styled-components";
import { colors, types } from "../../libs";

export const SupportTicketContainer = styled(Container)``;

export const SupportTicketRow = styled(Row)``;

export const TicketDetailsCol = styled(Col)``;


export const LoaderWrapper = styled.div`
    position: absolute; 
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;          
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

`;

export const BigTitle = styled.h2`
  ${types.headers.section};
  background: ${colors.text.textGradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 20px; 
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

export const Icon = styled.img`
  width: 20px;
  height: 20px;
`;

export const DashboardSearchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SearchBarWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 254px;
  position: relative;
`;

export const SearchInput = styled.input`
  flex: 1;
  border-radius: 20px;
  padding: 8px 16px;
  background: ${colors.background.grayBlack};
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  outline: none;

  &:focus {
    border-color: #aaa;
  }
`;

export const SearchIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-left: 10px;
  cursor: pointer;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.1);
  }
`;

export const PriorityDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
`;

export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const StatusSelect = styled(Form.Select)`
  width: 200px;
`;

export const PrioritySelect = styled(Form.Select)`
  width: 150px;
`;

export const NewTicketButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px; 
  padding: 13px 12px;
  img {
    width: 20px;
    height: 20px;
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 10px;
`;
export const StatusWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;  
`;

export const TabItem = styled.div`
   ${types.body.label}
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  cursor: pointer;
  opacity: 0.7;

  &.active {
    opacity: 1;
    background: ${colors.text.textGradient};
    -webkit-background-clip: text;
  
  }

  img {
    width: 20px;
    height: 20px;
  }
`;

export const TabBorderLine = styled.div`
  border: 1px solid ${colors.background.lightWhite};
`;

export const selectStyles = {
  menu: (baseStyles) => ({
    ...baseStyles,
    background: colors.background.formField,
    borderColor: "transparent",
    color: colors.text.white,
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    background: state.isFocused ? "#ccc" : colors.background.formField,
    color: state.isSelected ? colors.text.white : state.isFocused ? colors.background.formField : colors.text.white,
  }),
  singleValue: (baseStyles) => ({
    ...baseStyles,
    color: colors.text.white,
  }),
  control: (baseStyles, state) => ({
    ...baseStyles,
    height: "50px",
    background: colors.background.formField,
    color: colors.text.white,
    border: state.isFocused ? "1px solid transparent" : "1px solid transparent",
  }),
  multiValue: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: colors.text.gray,
    color: colors.text.white
  }),
  multiValueLabel: (baseStyles) => ({
    ...baseStyles,
    color: colors.text.white
  }),
  multiValueRemove: (baseStyles) => ({
    ...baseStyles,
    color: colors.text.white
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: colors.text.gray,
    fontSize: types.body.label
  }),
};

export const NoTicketContainer = styled.div`
  display: flex;
  justify-content: flex-start; 
  align-items: center;
  height: 60vh; 
  width: 100%;
  padding-left: 20px;
`;

export const NoTicketCard = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  text-align: left; 
  background: ${colors.background.black};
  padding: 20px;
  margin: 20px 0px;
  border: 1px solid ${colors.background.lightWhite};
  width: 100%;
`;

export const NoTicketTitle = styled.h3`
  ${types.headers.small}
  margin-bottom: 5px;
  margin: 10px 0;
`;

export const NoTicketDescription = styled.p`
   ${types.body.subtitle}
  margin-bottom: 15px;
  color:${colors.text.lightGray};
`;

